import { Injectable } from '@angular/core';
import { ValidatorFn, FormControl } from '@angular/forms';
import { Card, ICardInfo } from '../../model/models/card/card.interface';
import { PaymentMethodType } from '../../model/types/payment-method-type';
import { APP_CONFIG } from '../../environment';

@Injectable()
export class CardProvider {

  constructor() {
  }

  getLuhnCheckValidator(): ValidatorFn {
    const validator: ValidatorFn = (control: FormControl) => {
      let validator = null;
      const valid = this.isLuhnCheckValid(control.value);
      
       return valid ? null : {isLuhnCheckValid: false};
    }

    return validator;
  }

  isLuhnCheckValid(value): boolean {
    if (/[^0-9-\s]+/.test(value))
      return false;

    let nCheck = 0, bEven = false;
    value = value.replace(/\D/g, '');

    for (let n = value.length - 1; n >= 0; n--) {
      const cDigit = value.charAt(n);
      let nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }
      nCheck += nDigit;
      bEven = !bEven;
    }
    return (nCheck % 10) === 0;
  }

  mapCard(cardInfo: ICardInfo, formData, state): Card {
    const expirationDate: string[] = cardInfo.expirationDate.split('-');
    expirationDate[0] = expirationDate[0].length === 2 ? '20'+expirationDate[0] : expirationDate[0];
    let card: Card = {
      accountExpirationMonth: expirationDate[1],
      accountExpirationYear: expirationDate[0],
      cardExpiryDate: expirationDate[0]+'-'+expirationDate[1],
      expirationDate: expirationDate[0]+'-'+expirationDate[1],
      cardNumber: cardInfo.cardNumber,
      cardType: cardInfo.cardType,
      cVV: cardInfo.cvv,
      firstName: formData['firstName'],
      lastName: formData['lastName'],
      billingCountry: formData['billingCountry'],
      billingAddress: formData['billingAddress'],
      billingCity: formData['billingCity'],
      billingState: state.value,
      billingPostalCode: formData['billingPostalCode'],
      cardNumberMasked: "",
      isDebit: cardInfo.cardType === PaymentMethodType.DebitCard,
      stateLabel: state.text,
      isCvnRequired: formData['isCvnRequired']
    }

    return card;
  }

  updateCardAddress(card, billingAddress) {
    let newCard = {
      ...card,
      billingCountry: billingAddress['billingCountry'],
      street: billingAddress['billingAddress'],
      city: billingAddress['billingCity'],
      stateProvince: billingAddress['billingStateProvince'],
      postCode: billingAddress['billingPostalCode']
    }
    return newCard;
  }

  cardBinNumberValidator(binNumber): ValidatorFn {
    const validator: ValidatorFn = (control: FormControl) => {
      let validator = null;
      const valid = this.isFormBinControlValid(control.value);
      return valid ? null : {isFormBinControlValid: false};
    }
    return validator;
  }

  isFormBinControlValid(cardNumber) {
    let riaPrepaidCardBinNumber = APP_CONFIG.region.riaPrepaidCardBinNumber;
    if(cardNumber && cardNumber.length >= 8 && riaPrepaidCardBinNumber && cardNumber.replace(/\s+/g, "").substring(0,8) === riaPrepaidCardBinNumber){
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/card/card.ts